/*
 * @Author: zl
 * @Date: 2022-03-29 11:50:49
 * @LastEditTime: 2022-12-08 14:43:33
 * @LastEditors: zl
 * @Description: 形象进度
 */
import request from '@/api/request'

/**
 * 首页 - 工程形象进度 - 分页查询 
 * 接口管理员： 郑志会
 */
export const getEngineeringSchedule = function (data) {
    return request({
        url: '/auditschedule/getEngineeringSchedule',
        method: 'post',
        data,
    })
}



/**
 * 首页 - 形象进度-形象进度统计
 * 接口管理员： 崔北超
 */
export const selectSchedulestatistics = function (data) {
    return request({
        url: '/auditschedule/selectSchedulestatistics',
        method: 'post',
        data,
    })
}

/**
 * 首页 - 形象进度-形象进度-项目总体形象进度列表数据
 * 接口管理员： 郑志会
 */
export const getProjectScheduleData = function (data) {
    return request({
        url: '/auditProjectSchedule/getProjectScheduleData',
        method: 'post',
        data,
    })
}

/**
 * 首页 - 形象进度-项目总体形象进度详情
 * 接口管理员： 郑志会
 */
export const getProjectScheduleInfo = function (data) {
    return request({
        url: '/auditProjectSchedule/getProjectScheduleInfo',
        method: 'post',
        data,
    })
}

/**
 * 首页 - 形象进度-获取表头
 * 接口管理员： 崔北超
 */
export const selectTree = function (data) {
    return request({
        url: '/sysTemplateSchedule/selectTree',
        method: 'post',
        data,
    })
}
